import { useEffect, useState } from "react";
import { sessionStorageService } from "@entrilia/shared/services/storage";

const getMarkerKey = (artifactId: string): string => `artifact-compare-pending:${artifactId}`;

const useCompareLostOnReload = (artifactId: string, hasPendingCompare: boolean): boolean => {
  const [isCompareLostOnReload, setIsCompareLostOnReload] = useState(false);

  useEffect(() => {
    const key = getMarkerKey(artifactId);
    if (sessionStorageService.getItem<boolean>(key)) {
      // eslint-disable-next-line @eslint-react/set-state-in-effect -- read after mount: the panel this one replaces is cleaned up only after this one renders
      setIsCompareLostOnReload(true);
      sessionStorageService.removeItem(key);
    }
  }, [artifactId]);

  // A page reload runs no cleanup, so the marker it leaves behind tells the next panel the compare was lost.
  useEffect(() => {
    if (!hasPendingCompare) {
      return;
    }
    const key = getMarkerKey(artifactId);
    sessionStorageService.setItem(key, true);
    return () => sessionStorageService.removeItem(key);
  }, [artifactId, hasPendingCompare]);

  return isCompareLostOnReload;
};

export default useCompareLostOnReload;
